import * as yup from "yup";
import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";

export const ConfigurarEmailUnicoSchema = yup.object().shape({
  email: yup
    .string()
    .required(mensagemDeErroPadrao("E-mail da administradora"))
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "E-mail inválido!"),
});